// extracted by mini-css-extract-plugin
export default {"warning":"lookupOptions_warning__sJ0oz","sm":"lookupOptions_sm__mgYGN","sprite":"lookupOptions_sprite__-zgcf"};